/**
 * Venue display names. Title-casing the internal key gives "B2c2" and
 * "Falconx", which reads as a bug to anyone who knows these counterparties.
 */
const VENUE_LABEL: Record<string, string> = {
  b2c2: "B2C2",
  cumberland: "Cumberland",
  wintermute: "Wintermute",
  falconx: "FalconX",
  galaxy: "Galaxy",
  kraken: "Kraken",
  fireblocks: "Fireblocks",
  scrypt: "Scrypt",
  gsr: "GSR",
};

export function venueName(v: string | null | undefined): string {
  if (!v) return "—";
  return VENUE_LABEL[v.toLowerCase()] ?? v;
}
